import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const isAr = i18n.language === 'ar';

  const toggle = () => {
    i18n.changeLanguage(isAr ? 'en' : 'ar');
  };

  return (
    <button
      onClick={toggle}
      className="px-2.5 py-1.5 rounded-lg text-xs font-semibold border border-border text-muted-foreground hover:text-foreground hover:border-primary/40 transition-colors"
    >
      {isAr ? 'EN' : 'AR'}
    </button>
  );
};

export default LanguageSwitcher;
